<template>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb transparent">
      <li class="breadcrumb-item" v-bind:class="{ active: item.active }" v-for="item in $props.navPath" :key="item.id">
        <span v-bind:class="{ active: item.active }" @click="navigate(item.href)">{{ item.text }}</span>
      </li>
    </ol>
  </nav>
</template>

<style lang="scss" scoped>
.breadcrumb {
  margin-bottom: 0 !important;

  &.transparent {
    background-color: unset;
  }
  .breadcrumb-item + .breadcrumb-item::before {
    content: "-";
  }

  .breadcrumb-item {
    font-family: Open Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0em;

    color: var(--client-brand-color);

    a {
      // font-weight:400;
      text-decoration: none;
    }

    .active {
      color: var(--secondary-font-color) !important;
      // font-weight:600;
      cursor: pointer;
    }
  }
}
</style>

<script>
export default {
  name: "breadcrumb",

  props: {
    classes: {
      type: String,
      default: "transparent",
    },
    navPath: {
      type: Array,
      required: true,
    },
  },
  computed: {},

  methods: {
    navigate(href) {
      this.$emit("navigate", href);
    },
  },
};
</script>
